/**
 * Match phases (§1.10): weapons release, capitals exposed (10:00, §1.11), leader beacon
 * (every 60 s from 12:00), final phase; critical capitals that were not hit again recover.
 */
import { BALANCE } from '../balance.js';
import { isAlive, structureActive } from '../entities.js';
import type { Ghost, MatchState, SimEvent } from '../types.js';
import { capitalSystem } from './capital.js';

const P = BALANCE.phases;

export function phasesSystem(state: MatchState, events: SimEvent[]): void {
  const t = state.tick;
  if (t === P.releaseTick) events.push({ type: 'phase', phase: { kind: 'release', a: 0, b: 0, tick: t } });
  if (t === P.capitalsExposedTick) events.push({ type: 'phase', phase: { kind: 'capitalsExposed', a: 0, b: 0, tick: t } });
  if (t === P.finalTick) events.push({ type: 'phase', phase: { kind: 'final', a: 0, b: 0, tick: t } });
  if (t >= P.beaconTick && (t - P.beaconTick) % P.beaconIntervalTicks === 0) beacon(state, events);
  capitalSystem(state, events);
}

/** Current score leader among alive players (ties → lower id), 0 if none. */
export function scoreLeader(state: MatchState): number {
  let best = -1;
  let id = 0;
  for (const p of state.players) {
    if (isAlive(p) && p.score > best) {
      best = p.score;
      id = p.id;
    }
  }
  return id;
}

function beacon(state: MatchState, events: SimEvent[]): void {
  const leader = scoreLeader(state);
  if (!leader) return;
  const cities: Ghost[] = [];
  for (const e of state.entities.values()) {
    if (e.kind === 'city' && e.owner === leader && structureActive(state, e)) {
      cities.push({ id: e.id, kind: 'city', owner: leader, x: e.x, y: e.y, tick: state.tick, extra: e.level });
    }
  }
  events.push({ type: 'phase', phase: { kind: 'beacon', a: leader, b: 0, tick: state.tick } });
  events.push({ type: 'beacon', leader, cities });
}
